
// Javascript extension
Number.prototype.mod = function(n)
{
	return ((this%n)+n)%n;
};

// Request animation frame
window.requestAnimationFrame = window.requestAnimationFrame
    || window.mozRequestAnimationFrame
    || window.webkitRequestAnimationFrame
    || window.msRequestAnimationFrame
    || function(f){return setTimeout(f, 1000/60)} // simulate calling code 60

window.cancelAnimationFrame = window.cancelAnimationFrame
    || window.mozCancelAnimationFrame
    || function(requestID){clearTimeout(requestID)} //fall back



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'whatwg-fetch'

import Vue from 'vue'
import Vuex from 'vuex'
import { mapGetters } from 'vuex';
import App from './App'
import router from './router'
import store from './store'
import modernizr from '../.modernizrrc.js'
import moment from 'moment'
import Resumable from 'resumablejs'
import VueBreadcrumbs from 'vue-breadcrumbs'
import VueAlert from '@vuejs-pt/vue-alert'
import VueMq from 'vue-mq'
import VueScrollTo from 'vue-scrollto'
import VueDragscroll from 'vue-dragscroll'
import SocialSharing from 'vue-social-sharing'
import VueCarousel from 'vue-carousel';
import VueCookies from 'vue-cookies'
import VueGtm from 'vue-gtm';
import VCalendar from 'v-calendar';
import SlideUpDown from 'vue-slide-up-down';
import { map, filter, keys, includes, find, forEach, get, has } from 'lodash';
import wysiwyg from "vue-wysiwyg";

var allSettled = require('promise.allsettled');

require('@/css/grunticon/icons.data.svg.css')

import ApiWrapper from '../includes/ApiWrapper.js';
const api = new ApiWrapper(process.env.ROOT_API);
Vue.prototype.$apiPath = process.env.ROOT_API;
Vue.prototype.$api = api;

Vue.prototype.$eventBus = new Vue();
Object.defineProperty(Vue.prototype, '$resumable', { value: Resumable });
Object.defineProperty(Vue.prototype, '$moment', { value: moment });

Vue.prototype.isPlainObject = function(input){
	return input && !Array.isArray(input) && typeof input === 'object';
};
Vue.prototype.trackEvent = function(track)
{
	var self = this;

	if(!window.dataLayer) { return; }

	if(_.isString(track))
	{
		track = track.split("|");
	}

	// Must have a non-empty array by this point
	if(!Array.isArray(track)) { return; }
	if(track.length === 0) { return; }


	// Add event (which might be omitted)
	if(track[0] !== "gaTriggerEvent") { track.unshift("gaTriggerEvent"); }

	// Determine non-interaction hit value
	var nonInteractionHit = true;		// Assume true
	if(typeof track[5] !== "undefined")
	{
		if(typeof track[5] === "string" && track[5].toLowerCase() === 'false')
		{
			nonInteractionHit = false;
		}
		else if(typeof track[5] === "boolean")
		{
			nonInteractionHit = track[5];
		}
	}

	self.$gtm.trackEvent({
		event: track[0],
		category: track[1] || '',
		action: track[2] || '',
		label: track[3] || '',
		value: track[4] || '',
		noninteraction: nonInteractionHit
	});
};

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueBreadcrumbs)
Vue.use(VueAlert)
Vue.use(VueMq, {
	breakpoints: {
		mob: 481,
		ptab: 769,
		ltab: 1024,
		desk: Infinity,
	}
});
Vue.use(VueScrollTo)
Vue.use(VueDragscroll)
Vue.use(SocialSharing)
Vue.use(VueCarousel)
Vue.use(VueCookies)
Vue.use(VueGtm, {
  id: 'GTM-PNK442D',
  debug: process.env.NODE_ENV === 'development',
  vueRouter: router
});
Vue.use(VCalendar)
Vue.component('slide-up-down', SlideUpDown)
Vue.use(wysiwyg, {
  hideModules: {
		"justifyLeft": true,
		"justifyCenter": true,
		"justifyRight": true,
		"code": true,
		"orderedList": true,
		"image": true,
		"table": true,
		// "removeFormat": true,
		"separator": true
	},
  forcePlainTextOnPaste: true
});

Vue.filter('formatDate', function(value) {
	if (value) {
		return moment(String(value)).format('Do MMMM YYYY')
	}
})
Vue.filter('formatDateNews', function(value) {
	if (value) {
		return moment(String(value)).format('MMM YYYY')
	}
})
Vue.filter('formatDateShort', function(value) {
	if (value) {
		return moment.isMoment(value) ? value.format('DD MMM YYYY') : moment(value).format('DD MMM YYYY')
	}
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router: router,
	store: store,
	components: { App },
	template: '<App/>',
	data: {
		windowWidth: 0,
 		windowHeight: 0,
		headerHeight: 0,
		resizeTimer: undefined,
		isScrolled: window.scrollY > 0,

		user: null,
		userSelectedRegionKey: VueCookies.isKey("userSelectedRegionKey") && VueCookies.get("userSelectedRegionKey") !== "null" ? VueCookies.get("userSelectedRegionKey") : null,
		userPromiseResolved: false,
		appInitialised: false,
		appInitialisationFailed: false,
		appLoading: true,
		appImmediateLoading: false,
		redirectUrl: null,

		games: [],
		gamesPromise: null,
		gamesPromiseResolved: false,

		gameDemo: null,
		gameVideoId: null,
		gameAsset: null,
		tournamentsVisible: false,
		showLoginForm: null,

		assetExpose: null,

		hubspotScriptAdded: false,

		adminTitle: null,
	},
	computed: {
		...mapGetters({
			'fallbackDefaultRegionKey': 'app/fallbackDefaultRegionKey',
			'flatRegions': 'app/flatRegions',
		}),
  	operatorLogo: function()
		{
			var self = this;
			var styles = {};

			if(self.$root.$data.user)
			{
				if(self.$root.$data.user.userType === 'igt')
				{
					styles = { backgroundImage: 'url(' + require("@/assets/img/logo--circle.png") + ')' };
				}
				else
				{
					var logo = get(self.$root.$data, 'user.operator.logo.link', false);
					if(logo)
					{
						styles = { backgroundImage: 'url(' + logo + ')' };
					}
				}
			} else {
				styles = { backgroundImage: 'url(' + require("@/assets/img/logo--circle.png") + ')' };
			}

			return styles;
		},
		userRegions: function()
		{
			if(this.user)
			{
				if((has(this.user, 'regions') && this.user.regions.length > 0 ) || (has(this.user, 'operator.regions') && this.user.operator.regions.length > 0 ))
				{
					var regions = has(this.user, 'regions') && this.user.regions.length > 0 ? this.user.regions : this.user.operator.regions;
					return map(regions, region =>
					{
						var match = this.flatRegions[region.region];
						match.isDefault = region.isDefault;
						return match;
					})
				}
				else
				{
					return [];
				}
			}

			return null;
		},
		userDefaultRegion: function()
		{
			if(this.userRegions)
			{
				const defaultRegion = find(this.userRegions, {isDefault: true});
				const key = defaultRegion ? defaultRegion.key : this.fallbackDefaultRegionKey;
				return this.flatRegions[key];
			}

			return null;
		},
		userSelectedRegion: function()
		{
			if(this.userSelectedRegionKey)
			{
				return this.flatRegions[this.userSelectedRegionKey];
			}

			return null;
		},
		tournamentsUrl() {
			try {
				const urlParams = {
					u: this.encodeString(this.user.id.toString()),
					f: this.encodeString(this.user.firstName.toString()),
					l: this.encodeString(this.user.surname.toString()),
				}
				return 'https://rgs-demo04.lab.wagerworks.com/demoSite/microPromotions/index.html#/' +
					'?u=' + encodeURIComponent(urlParams.u) +
					'&f=' + encodeURIComponent(urlParams.f) +
					'&l=' + encodeURIComponent(urlParams.l)
			} catch (e) {
				return false
			}
		}
	},
	watch: {
		// Fail-safe for direct access of disallowed URLs. Make sure we have the user though! (If not, it's fine as we verifyPermissions at that step anyway)
		appLoading: function (to, from)
		{
			var self = this;
			if(to === false && this.userPromiseResolved)
			{
				self.verifyPermissions();
			}
		},
		$route (to, from){
			var self = this;
			this.show = false;

			// Hub spot tracking
			var _hsq = window._hsq = window._hsq || [];

			if (!this.hubspotScriptAdded) {
				this.hubspotScriptAdded = true;

				_hsq.push(['setPath', to.fullPath]);

				if (process.env.NODE_ENV === "production") {
					var script = document.createElement('script');
					script.type = 'text/javascript';
					script.id = 'hs-script-loader'
					script.async = true;
					script.defer = true;
					script.src = '//js.hs-scripts.com/5484445.js';
					document.getElementsByTagName('head')[0].appendChild(script);
				}

			} else {
				_hsq.push(['setPath', to.fullPath]);
				_hsq.push(['trackPageView']);
			}


			// Process query strings
			if(self.$route.query.demo && self.games.length > 0 && self.user)
			{
				var game = find(self.games, {id: self.$route.query.demo});
				if(game) { self.gameDemo = game; }
			}
		},
		user: {
			handler: function(newVal) {
				if (newVal == null) {
					this.userSelectedRegionKey = null;
				} else {
					if(this.userSelectedRegionKey == null) {
						this.userSelectedRegionKey = this.userDefaultRegion ? this.userDefaultRegion.key : this.$store.state.app.fallbackDefaultRegionKey;
					}
				}
			},
			deep: true,
		},
		userSelectedRegionKey: function(to, from)
		{
			this.calculateReleaseDates();

			this.$cookies.set("userSelectedRegionKey", to, '7d');
		}
  },
	created: function()
	{
		var self = this;

		localStorage.setItem('changeHeroSlide', true);

		// Window events
		window.addEventListener('scroll', self.handleScroll);

		self.handleResize();
		window.addEventListener('resize', self.handleResize);

		window.addEventListener('click', self.handleWindowClick);


		// App Events
		self.$eventBus.$on('logout', self.verifyPermissions);

		// Get user
		var userPromise = self.getUser();
		var userPromiseSuccess = true;
		userPromise
		.catch((error) =>
		{
			// Clear any possible cookie values
			this.userSelectedRegionKey = null;

			// If it's just because the user isn't logged in, then it's actually a success
			if(!error.hasOwnProperty('message') || (error.message.indexOf("You are not authorised to make this request. Please login") == -1 && error.message.indexOf("You need to be logged in.") == -1 ))
			{
				userPromiseSuccess = false;
				self.$data.appInitialisationFailed = true;
			}
		})
		.finally(() => {
			self.userPromiseResolved = true;

			if(userPromiseSuccess === true)
			{
				self.verifyPermissions();
			}
		});


		this.getAllGamesPromise()
		.catch((error) =>
		{
			self.$data.appInitialisationFailed = true;
		});


		// When all are done, we are initialised (although not necessarily successful)
		allSettled([
			userPromise,
			self.gamesPromise,
		])
		.then(() =>
		{
			self.$data.appInitialised = true;
		});
	},
	beforeDestroy: function()
	{
		var self = this;
		window.removeEventListener('scroll', self.handleScroll);
		window.removeEventListener('resize', self.handleResize);
		window.removeEventListener('click', self.handleWindowClick);

		self.$eventBus.$off('logout', self.verifyPermissions);
	},
	methods: {
		handleScroll () {
			var self = this;

			self.isScrolled = window.scrollY > 0;
		},
		handleResize(evt)
		{
			this.$data.windowWidth = window.innerWidth
				|| document.documentElement.clientWidth
				|| document.body.clientWidth;
			this.$data.windowHeight = window.innerHeight
				|| document.documentElement.clientHeight
				|| document.body.clientHeight;

			this.$eventBus.$emit('window-resize', this.windowWidth, this.windowHeight);

			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(() =>
			{
				this.$eventBus.$emit('delayed-window-resize', this.windowWidth, this.windowHeight);
			}, 150);

		},
		handleWindowClick (evt) {
			this.$eventBus.$emit('window-click', evt);
		},
		verifyPermissions() {
			var self = this;

			if(self.$route.meta.onloadPermissions)
			{
				forEach(self.$route.meta.onloadPermissions, function(permission)
				{
					if(!self.userHasPermission(permission.levels))
					{
						if(permission.redirect.name && permission.redirect.name === 'Login')
						{
							self.$data.loginRedirect = self.$route;
						}
						self.$router.push(permission.redirect);
						return false;
					}
				});
			}
			if(self.$route.meta.permission)
			{
				var permission = self.$route.meta.permission;
				if(!self.userHasPermission(permission.levels))
				{
					if(permission.redirect.name && permission.redirect.name === 'Login')
					{
						self.$data.loginRedirect = self.$route;
					}
					self.$router.push(permission.redirect);
					return false;
				}
			}
		},
		getAllGamesPromise: function()
		{
			var self = this;
			self.gamesPromiseResolved = false;

		// Get all games
			self.gamesPromise = new Promise((resolve, reject) =>
			{
				self.$api.getAllGames(null, 0).then((data) =>
				{
					if(data.hasOwnProperty('data') && Array.isArray(data.data))
					{
						var allGames = data.data;

						for (let i = 0; i < allGames.length; i++)
						{
							let game = allGames[i];

							if(!game.hasOwnProperty('downloadableAssets'))
							{
								let assets = null;
								let privateFolder = game.gameCentre;

								if(privateFolder && privateFolder.length > 0)
								{
									privateFolder = privateFolder[0];

									if(privateFolder.hasChildren)
									{
										if(privateFolder.children && privateFolder.children.length === 1 && privateFolder.children[0].name.trim().toLowerCase() === game.gameName.trim().toLowerCase())
										{
											assets = privateFolder.children[0];
										}
										else
										{
											assets = privateFolder;
										}
										assets.name = game.gameName;

										if(game.assets.thumbnail && game.assets.thumbnail.length > 0)
										{
											assets.iconOverride = game.assets.thumbnail[0].link;
										}
									}
								}

								game.downloadableAssets = assets;
							}
						}

						// In the majority of cases, we only want active games
						allGames = self.calculateReleaseDates(allGames);
						self.games = filter(allGames, {isActive: true});
						// Resolve with the full list though (e.g. Roadmap usage)
						resolve(allGames);
					}
					else
					{
						resolve(self.games);
					}

				}).catch((error) => {
					reject(error);
				});
			})
			.finally(() => {
				self.gamesPromiseResolved = true;
			});

			return self.gamesPromise;
		},
		calculateReleaseDates(games) {
			games = typeof games === 'undefined' ? this.games : games

			forEach(games, game => {
				let releaseDate = game.releaseDate
				let displayReleaseDate = false

				if (this.userSelectedRegionKey && game.isReleaseDatePerRegion) {
					const regionReleaseDate = find(game.regions, { region: this.userSelectedRegionKey })
					if (regionReleaseDate && regionReleaseDate.releaseDate) {
						// If found and a date is set (could be empty)
						releaseDate = regionReleaseDate.releaseDate
						displayReleaseDate = regionReleaseDate.displayReleaseDate
					}
				} else {
					displayReleaseDate = game.displayReleaseDate
				}

				this.$set(game, 'regionalReleaseDate', releaseDate)
				this.$set(game, 'regionalDisplayReleaseDate', displayReleaseDate)
			});

			return games
		},
		getExtension: function(filename)
		{
			return filename.indexOf('.') !== -1 ? filename.split('.').slice(-1)[0] : null;
		},
		requireIcon(name, type)
		{
			var allowed = [
				'ai',
				'archive',
				'document',
				'fla',
				'folder',
				'image',
				'pdf',
				'psd',
				'swf',
				'unknown',
				'video',
				'zip',
			];
			var ext = this.getExtension(name);
			var icon = allowed.indexOf(ext) !== -1 ? ext : (allowed.indexOf(type) !== -1 ? type : 'unknown');

			return require("@/assets/img/icons/" + icon + "@2x.png");
		},
		gameHasDemo (game) {
			if(game.demoLinkUrl && game.demoLinkUrl !== "" && game.demoLinkUrl !== null && game.demoLinkUrl !== 'null') {
				return true;
			} else {
				return game && game.demoTechnology && game.demoEnvironment && game.demoCurrency && game.demoTechnology !== 'null' && game.demoEnvironment !== 'null' && game.demoCurrency !== 'null'
			}
		},
		getGameDemo (game) {
			const self = this

			if (!self.gameHasDemo(game)) {
				return null
			}

			if(game.demoLinkUrl && game.demoLinkUrl !== "" && game.demoLinkUrl !== null && game.demoLinkUrl !== 'null') {
				return encodeURI(game.demoLinkUrl.replace(/\s/g, ''))
			}

			const userId = self.user ? self.user.id : 'unknown'
			const uniqueId = game.demoUniqueId ? userId + '-' + Math.floor(Date.now() / 1000) : userId

			let softwareID = null
			// Add / Edit Game - Demo Config
			if (game.softwareIds && game.softwareIds.length > 0) {
				softwareID = game.softwareIds[0].softwareId
			}
			// Everywhere else
			else if (game.softwareId && game.softwareId.length > 0) {
				softwareID = game.softwareId[0]
			}
			const amount = game.demoCurrency === 'GBP' ? '0.01' : '1.0'
			const operatorCode = game.demoOperatorCode || 'SKB'
			const skinCode = game.demoSkinCode || 'SKB'
			const countryCode = game.demoCountryCode || 'GB'
			const language = game.demoLanguage || 'en'
			const url = game.demoEnvironment === 'cloud' ? `https://rgs.demo01.rgs.cloud/skb/gateway` : `https://rgs-${game.demoEnvironment}.lab.wagerworks.com/skb/gateway`

			const value = (game.demoTechnology === 'HTML') ?
				`${url}?
					nscode=${operatorCode}&
					countrycode=${countryCode}&
					securetoken=RGS-${game.demoEnvironment.toUpperCase()}.SKB&
					skincode=${skinCode}&
					technology=${game.demoTechnology}&
					forcelat=53.481111&
					loadskin=IGT&
					ipaddress=80.0.57.1&
					forcelng=-2.1025&
					forcelocationstatus=0&
					forcelocationmessage=-SUCCESS&
					presenttype=STD&
					minbet=${amount}&
					denomamount=${amount}&
					currencycode=${game.demoCurrency}&
					uniqueid=${uniqueId}&
					language=${language}&
					softwareid=${softwareID}` :
				`https://ipl-${game.demoEnvironment}.lab.wagerworks.com/games/index.html?
					nscode=WW&
					countrycode=GB&
					securetoken=1234&
					skincode=GEN1&
					presenttype=HTML&
					minbet=${amount}&
					denomamount=${amount}&
					currencycode=${game.demoCurrency}&
					language=en&
					softwareid=${softwareID}&
					uniqueid=${uniqueId}&
					channel=MOB&
					loadskin=IGT`
			return encodeURI(value.replace(/\s/g, ''))
		},
		getUser() {

			var self = this;
			var promise = self.$api.getActiveUser();
			promise.then((success) => {
				var user = success.data;
				user.fullName = user.firstName + " " + user.surname;
				user.trackName = user.fullName + " (id:" + user.id + ")";
				self.$data.user = user;
			}).catch((error) => {
				console.log(error);
			});

			return promise;
		},
		userHasPermission(permissionLevels) {
			var self = this;
			var user = self.$data.user

			if (!user || !includes(keys(permissionLevels), user.userType) || !includes(permissionLevels[user.userType], user.userGroup))
			{
				return false;
			}

			return true;
		},
		encodeString(str) {
			/**
			 * Step 1. Reverse the string
			 * Step 2. Base64 encode the reversed string
			 * Step 3. Reverse the base64 encoded reversed string
			 * Step 4. Base64 encode the revered base64 encoded reversed string
			 * Step 5. Reverse the base64 encoded reversed base64 encoded reversed string
			 * Step 6. ????
			 * Step 7. Profit
			 */
			return this.reverseString(btoa(this.reverseString(btoa(this.reverseString(str)))))
		},
		reverseString(str) {
			return str.split('').reverse().join('')
		}
	},
})



// WEBPACK FOOTER //
// ./src/main.js